import { render, staticRenderFns } from "./enterMail.vue?vue&type=template&id=5c0ec199"
import script from "./enterMail.vue?vue&type=script&lang=ts"
export * from "./enterMail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports